import { useCallback, useEffect, useState } from 'react'

export type ThemeChoice = 'light' | 'dark' | 'system'

const KEY = 'ssm-theme'

function apply(choice: ThemeChoice) {
  const root = document.documentElement
  if (choice === 'system') {
    // Removing the attribute hands control back to prefers-color-scheme.
    root.removeAttribute('data-theme')
  } else {
    root.setAttribute('data-theme', choice)
  }
}

function read(): ThemeChoice {
  const v = localStorage.getItem(KEY)
  return v === 'light' || v === 'dark' ? v : 'system'
}

/* Applied before first paint in index.html too, so there is no flash of the
 * wrong theme; this hook keeps React in sync with that. */
export function useTheme() {
  const [choice, setChoice] = useState<ThemeChoice>(read)

  useEffect(() => { apply(choice) }, [choice])

  const set = useCallback((next: ThemeChoice) => {
    if (next === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, next)
    setChoice(next)
  }, [])

  const toggle = useCallback(() => {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark'
      || (choice === 'system'
          && window.matchMedia('(prefers-color-scheme: dark)').matches)
    set(isDark ? 'light' : 'dark')
  }, [choice, set])

  return { choice, set, toggle }
}
